// TODO: make it flag on metric - conversion: boolean
const conversionRateMetrics = ['proceed_rate', 'dropoff_rate'];
export const hasConversionData = (metric: string) => conversionRateMetrics.includes(metric);
